// The grey tiles' color is {r: GREY_RGB, g: GREY-RGB, b: GREY_RGB}
// r, g and b have the same value
export const GREY_RGB = 0.21586050010324415;
